'use client';

import Link from 'next/link';
import { c } from '../../../utils/tailwind-merge';
import { Button } from '../../atoms/Button/Button';
import { LinkV2 } from '../../atoms/Link/Link.v2';
import { Modal } from '../../molecules/Modal/Modal';
import { useModal } from '../../molecules/Modal/useModal';
import { RichText } from '../../molecules/RichText/RichText';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../molecules/Table/Table';
import { LicensingTableProps } from './LicensingTable.types';

export const LicensingTable = ({
  termsOfServiceLink,
  customAgreement,
  microcopy,
  className = '',
}: LicensingTableProps) => {
  const [isActive, toggle] = useModal();

  const richTextLinkStyles = c(
    'tiny-text break-normal text-black dark:text-content',
    '[&_a]:tiny-text-link [&_a]:text-link [&_a]:no-underline [&_a:visited]:tiny-text-link',
    '[&_div]:tiny-text-link [&_div]:text-link [&_div]:no-underline [&_div:visited]:tiny-text-link'
  );

  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>

      <TableHeader className="sr-only">
        <TableRow>
          <TableHead>{microcopy.headerColumn1}</TableHead>
          <TableHead>{microcopy.headerColumn2}</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        <TableRow>
          <TableHead scope="row">{microcopy.licenseAgreement}</TableHead>
          <TableCell>
            <LinkV2 asChild size="small">
              <Link
                href={termsOfServiceLink}
                className="tiny-text"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${microcopy.licenseAgreement}: ${customAgreement ? customAgreement : microcopy.standardEula}`}
              >
                {customAgreement
                  ? microcopy.customEulaLink
                  : microcopy.standardEula}
              </Link>
            </LinkV2>
          </TableCell>
        </TableRow>
        {!customAgreement ? (
          <TableRow>
            <TableHead scope="row">{microcopy.licenseType}</TableHead>
            <TableCell
              className={c('break-normal [&_button]:no-underline', className)}
            >
              <LinkV2 asChild size="small" className="capitalize">
                <button
                  type="button"
                  onClick={toggle}
                  aria-expanded={isActive}
                  aria-label={`${microcopy.licenseType}: ${microcopy.extensionAsset}`}
                >
                  {microcopy.extensionAsset}
                </button>
              </LinkV2>

              <div>
                <Modal
                  title={microcopy.extensionAssetTitle}
                  closeLabel={microcopy.extensionAssetClose}
                  isActive={isActive}
                  closeModal={toggle}
                  titleClassName={c('!mx-11')}
                  actions={
                    <div className="flex gap-2">
                      <Button
                        label={microcopy.extensionAssetClose}
                        onClick={toggle}
                        style="secondary"
                      />
                    </div>
                  }
                  actionsSide="right"
                >
                  <RichText
                    html={microcopy.extensionAssetDescription}
                    className={c(richTextLinkStyles, 'mx-11 text-left')}
                  />
                </Modal>
              </div>
            </TableCell>
          </TableRow>
        ) : null}
      </TableBody>
    </Table>
  );
};
